export var CREATE_PASSWORD = 'src/NewPasswordPage/CREATE_PASSWORD_REQUEST';
export var CREATE_PASSWORD_SUCCESS = 'src/NewPasswordPage/CREATE_PASSWORD_SUCCESS';
export var CREATE_PASSWORD_EXPIRED = 'src/NewPasswordPage/CREATE_PASSWORD_EXPIRED';
export var CREATE_PASSWORD_FAIL = 'src/NewPasswordPage/CREATE_PASSWORD_FAIL';
export var APP_META = 'src/NewPasswordPage/APP_META';
export var APP_META_SUCCESS = 'src/NewPasswordPage/APP_META_SUCCESS';
export var APP_META_FAIL = 'src/NewPasswordPage/APP_META_FAIL';
export var APP_USER_REQUEST = 'src/NewPasswordPage/APP_USER_REQUEST';
export var APP_USER_SUCCESS = 'src/NewPasswordPage/APP_USER_SUCCESS';
export var APP_USER_FAIL = 'src/NewPasswordPage/APP_USER_FAIL';
